export enum FilingType {
  UCC1 = 'UCC1',
  UCC3 = 'UCC3',
  UCC5 = 'UCC5',
}
